/*! tailwindcss v4.2.2 | MIT License | https://tailwindcss.com */
@layer components {
  .truncated {
    &:where(:has(.rightHalf)) {
      display: grid;
      grid-template-columns: minmax(0,auto) auto 1fr;
      max-height: 1lh;
      align-items: flex-start;
      overflow: clip;
      word-break: break-all;
      white-space: normal;
      text-align: justify;
      &:where(.inline) {
        display: inline-grid;
      }
    }
    &:where(:not(:has(.rightHalf))) {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &:where(.inline) {
        display: inline;
      }
    }
  }
  .rightHalf {
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    &::before,	&::after {
      content: "\200E";
    }
  }
}
